<div class="main-content">
  <div class="container-fluid">
    <div class="col-md-12">
      <app-card-icon-title [icon]="iconVisibilityTables"></app-card-icon-title>
      <hr />

      <div class="grid-container">
        <div *ngFor="let table of tables" class="border p-4 bg-white d-flex flex-column justify-content-between ">
            <h3 class="">{{table.name}}</h3>
            <p>Status: {{table.status == 0 ? 'Visible': 'Invisible'}}</p>
            <div>
              <button class="btn btn-info" *ngIf="table.status == 0" (click)="closeOpenTable(table.name, 1)">Hide Table</button>
               <button class="btn btn-success" *ngIf="table.status == 1" (click)="closeOpenTable(table.name, 0)">Show Table</button>
            </div>
        </div>
      </div>
      <!-- <div class="d-flex align-items-center">
        <span>Visibility Tables</span>

      </div> -->

    </div>
  </div>
</div>
